import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { feedActions, useActions } from '../../../store';
import { Icon, Stack } from '../../UI';
import { RoutePaths } from '../../../constants';

import { HeaderLogoProps } from './HeaderLogo.types';
import './HeaderLogo.scss';

const b = cn('header');

export const HeaderLogo = (props: HeaderLogoProps) => {
    const { className } = props;

    const { reset } = useActions(feedActions);

    const handleClick = () => {
        reset();
    };

    return (
        <Link to={RoutePaths.Main} className={b('logo').mix(className)} onClick={handleClick}>
            <Stack direction="row" spacing={4} alignItems="center">
                <Icon className={b('logo-icon')} name="logo" />
                <span>промптхаб</span>
            </Stack>
        </Link>
    );
};
